import { DialogContent, DialogTitle, Grid } from '@mui/material';
import React from 'react';
import { ClientDTO } from 'wisestep-api';
import { WsButton, WsIconCross, WsTypography, WsTypoVariants } from 'wisestep-base';

import ClientDetailsForm from './ClientDetailsForm';

interface CreateClientFormProps {
  onClose(): void;
  onSave(client: ClientDTO): void;
  defaultValues?: ClientDTO;
}

export const CreateClientForm = ({ onClose, onSave, defaultValues }: CreateClientFormProps) => (
  <>
    <DialogTitle>
      <Grid item container justifyContent="space-between">
        <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
          Create Client
        </WsTypography>
        <WsButton startIcon={<WsIconCross />} onClick={onClose} variant="text">
          Close
        </WsButton>
      </Grid>
    </DialogTitle>
    <DialogContent>
      <Grid p={2}>
        <ClientDetailsForm
          source="JobPostingForm"
          defaultValues={defaultValues}
          getClient={onSave}
        />
      </Grid>
    </DialogContent>
  </>
);
